"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const Img_1 = __importDefault(require("../../Util/Img"));
const Button_1 = __importDefault(require("../../Util/Button"));
const helpers_1 = require("../../../lib/helpers");
// needed so it doesnt purge and we use dynamic classnames for logo.
const classes = [
    'md:block',
    'md:hidden',
    'sm:block',
    'sm:hidden',
    'xs:block',
    'xs:hidden',
    'lg:block',
    'lg:hidden',
];
const Logo = (props) => {
    const { children, src, href } = props;
    const images = [];
    if (typeof src === 'string' || Object.keys(src).length === 1) {
        images.push({
            className: '',
            src: typeof src === 'string' ? src : src[Object.keys(src)[0]],
        });
    }
    else {
        const getSortOrder = (sizeName) => ({
            xs: 0,
            sm: 1,
            md: 2,
            lg: 3,
        }[sizeName]);
        const sortedSizes = Object.keys(src).sort((a, b) => getSortOrder(a) - getSortOrder(b));
        const smallestSize = sortedSizes[0];
        const secondSmallestSize = sortedSizes[1];
        Object.keys(src).forEach((sizeName) => {
            images.push({
                className: sizeName === smallestSize ? `block ${secondSmallestSize}:hidden` : `hidden ${sizeName}:block`,
                src: src[sizeName],
            });
        });
    }
    return (react_1.default.createElement(Button_1.default, Object.assign({}, helpers_1.without(props, ['src']), { href: { href, className: 'contents' } }),
        images.map((image) => (react_1.default.createElement(Img_1.default, { size: props.size, key: image.className + image.src, src: image.src, className: image.className, alt: "logo" }))),
        children));
};
exports.default = withJourney_1.default('j-logo', Logo, { wrapsHref: false });
